import React, { useMemo, useState, useEffect, useRef } from "react";
import MaterialReactTable from "material-react-table";
import {
  Box,
  Button,
  Container,
  DialogActions,
  DialogContent,
  DialogTitle,
  Chip,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import {
  createTheme,
  ThemeProvider,
  Switch,
  FormControlLabel,
} from "@mui/material";
import "./BuroCrat.css";
import LoginProcess from "./loginProcess";
import Header from "./Header";
import { authFetch, getAuthInfo, redirectToLogin } from "./authFetch";

const AdminRequestEndpoint = process.env.REACT_APP_ADMIN_GETALL;
const RequestEndPoint = process.env.REACT_APP_REQUEST_END_POINT;
const ApprovalEndPoint = process.env.REACT_APP_APPROVE_END_POINT;
//const ApbEndPoint = process.env.REACT_APP_APB_END_POINT;
const DeleteEndPoint = process.env.REACT_APP_DELETE_END_POINT;
const filterEndPoint = process.env.REACT_APP_FILTER_END_POINT;
const forsaleEndPoint = process.env.REACT_APP_FORSALE_END_POINT;
const priceEndPoint = process.env.REACT_APP_PRICE_END_POINT;
const checkAdminEndPoint = process.env.REACT_APP_ISADMIN_END_POINT;
const approvedEmail = process.env.REACT_APP_APPROVEDEMAIL;

const Buro = (props) => {
  const [isLoading, setisLoading] = useState(true);
  const [FData, setFData] = useState([]);
  const [userinfo, setUserinfo] = useState();
  const [filterMine, setFilterMine] = useState(false);
  const [Login, setLogin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminList, setAdminList] = useState(false);

  const backupData = useRef();

  //const EndPoint = isAdmin ? AdminRequestEndpoint : RequestEndPoint;
  var EndPoint;

  useEffect(() => {
    //verficar se ele é admin!
    //para por o butao de admin a funcionar!
    var u = JSON.parse(sessionStorage.getItem("userinfo"));

    if (u !== null) {
      setUserinfo(u);
      afterLogin();
    } else {
      sessionStorage.removeItem("userinfo");
      setUserinfo(false);
    }
  }, []);

  function GettingData() {
    EndPoint = RequestEndPoint;

    if (filterMine) {
      EndPoint = filterEndPoint + userinfo.id;
    }

    if (adminList) {
      EndPoint = AdminRequestEndpoint;
    }

    useEffect(() => {
      var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
      const dataFetch = async (state) => {
        var h;
        if (adminList) {
          h = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userinfo.token,
          };
        } else {
          h = {
            "Content-Type": "application/json",
          };
        }

        var options = {
          method: "GET",
          mode: "cors",
          headers: h,
        };

        var data = await (await fetch(EndPoint, options)).json();

        if (data.statusCode) {
          logout();
        }

        if (FData.length === 0) {
          backupData.current = data;
          setFData(data);
          setisLoading(false);
        }
      };

      dataFetch();
    }, [FData]); // eslint-disable-line react-hooks/exhaustive-deps
  }

  //should be memoized or stable

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
  }

  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
  }

  function turnToPhrase(str) {
    str = replaceAll(str, "_", " ");
    str = replaceAll(str, "|", "\n");
    return str;
  }

  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  function created(date) {
    return new Date(Date.parse(date));
  }
  function createdString(d) {
    return (
      months[created(d).getMonth()] +
      " " +
      created(d).getDate() +
      ", " +
      created(d).getFullYear()
    );
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: "author", //normal accessorKey
        header: "Author",
        size: 50,
        grow: true, //a size: 12,
        enableEditing: false,
      },
      {
        accessorKey: "phrase", //access nested data with dot notation
        header: "Idea",
        accessorFn: (row) => turnToPhrase(row.phrase),

        enableEditing: false,
      },
      {
        accessorKey: "value", //access nested data with dot notation
        header: "value",
        accessorFn: (row) => row.value / 100,
      },
    ], // eslint-disable-next-line
    []
  );
  const columnsAdmin = useMemo(
    () => [
      {
        accessorKey: "phrase", //access nested data with dot notation
        header: "Idea",
        accessorFn: (row) => turnToPhrase(row.phrase),
        size: 50,
      },
      {
        accessorKey: "author", //normal accessorKey
        header: "Author",
        size: 50,
        grow: true, //a size: 12,
        enableEditing: false,
      },
      {
        accessorKey: "createdAt",
        header: "Creation Date",
        accessorFn: (row) => createdString(row.createdAt),
      },
      {
        accessorKey: "value",
        header: "Value",
        size: 5,
        accessorFn: (row) => row.value / 100 + " €",
      },
      {
        accessorKey: "series",
        header: "serie",
        size: 5,
        accessorFn: (row) =>
          row.series === 0
            ? "[1/1]"
            : row.series === 1
            ? "[1/10]"
            : row.series === 2
            ? "[1/20]"
            : row.series === 3
            ? "[1/200]"
            : "",
      },
      {
        accessorKey: "aproved",
        header: "Approved",
        size: 5,
        accessorFn: (row) =>
          row.approvals?.length === 0
            ? button0(row)
            : row.approvals?.length === 1
            ? button1(row)
            : button2(row),
      },
    ], // eslint-disable-next-line
    []
  );

  const openInSameTab = (url) => {
    window.open(url, "_self", "noopener,noreferrer");
  };

  async function handleDelete(row) {
    var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
    const h = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + userinfo.token,
    };
    var options = {
      method: "DELETE",
      mode: "cors",
      headers: h,
    };

    const response = await fetch(DeleteEndPoint + row.id, options);
    if (response.status !== 200) {
      logout();
      return;
    }
    if (response.ok) {
      const index = backupData.current
        .map((object) => object.id)
        .indexOf(row.id);

      setFData((oldArray) => [
        ...oldArray.slice(0, index),
        ...oldArray.slice(index + 1),
      ]);

      if (index > -1) {
        // only splice array when item is found
        backupData.current.splice(index, 1); // 2nd parameter means remove one item only
      }
    }
  }
  function filter() {
    setFilterMine(!filterMine);
    setFData([]);
  }

  function fadminList() {
    setAdminList(!adminList);
    setFData([]);
  }

  function getIcon(row) {
    var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));

    if (row.approvals.length === 0) {
      return "";
    }

    if (
      row.approvals.length === 1 &&
      row.approvals[0].user_id !== userinfo.id
    ) {
      return "";
    }

    if (
      row.approvals.length === 2 &&
      row.approvals[0].user_id !== userinfo.id &&
      row.approvals[1].user_id !== userinfo.id
    ) {
      return "";
    }

    return <CheckIcon />;
  }

  function button0(row) {
    async function handleAproval(row) {
      var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));

      const h = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userinfo.token,
      };

      var options = {
        method: "GET",
        mode: "cors",
        headers: h,
      };

      fetch(ApprovalEndPoint + userinfo.id + "/" + row.id, options)
        .then((response) => response.json())
        .then(function (data) {
          const index = backupData.current
            .map((object) => object.id)
            .indexOf(row.id);

          setFData((oldArray) => [
            ...oldArray.slice(0, index),
            data,
            ...oldArray.slice(index + 1),
          ]);
        });
    }
    return (
      <Button
        color="virgin"
        onClick={() => {
          handleAproval(row);
        }}
        variant="contained"
        endIcon={getIcon(row)}
      >
        0/2
      </Button>
    );
  }

  function button1(row) {
    async function handleAproval(row) {
      var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
      const h = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userinfo.token,
      };

      var options = {
        method: "GET",
        mode: "cors",
        headers: h,
      };

      fetch(ApprovalEndPoint + userinfo.id + "/" + row.id, options)
        .then((response) => response.json())
        .then(async function (data) {
          const index = backupData.current
            .map((object) => object.id)
            .indexOf(row.id);

          setFData((oldArray) => [
            ...oldArray.slice(0, index),
            data,
            ...oldArray.slice(index + 1),
          ]);

          // Send approval email when going from 1/2 to 2/2 (fully approved)
          if (data.approvals && data.approvals.length === 2) {
            try {
              await fetch(approvedEmail, {
                method: "GET",
                headers: { phrase: row.id.toString() },
              });
            } catch (err) {
              console.error("Failed to send approval email:", err);
            }
          }
        });
    }


    return (
      <Button
        color="bastard"
        onClick={() => {
          handleAproval(row);
        }}
        variant="contained"
        endIcon={getIcon(row)}
      >
        1/2
      </Button>
    );
  }
  function button2(row) {
    async function handleAproval(row) {
      var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));

     
      
      const h = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userinfo.token,
      };

      var options = {
        method: "GET",
        mode: "cors",
        headers: h,
      };

      fetch(ApprovalEndPoint + userinfo.id + "/" + row.id, options)
        .then((response) => response.json())
        .then(function (data) {
          if (data.statusCode === 201) {
            alert(data.message);
            return;
          }

          const index = backupData.current
            .map((object) => object.id)
            .indexOf(row.id);
           
        
          
          setFData((oldArray) => [
            ...oldArray.slice(0, index),
            data,
            ...oldArray.slice(index + 1),
          ]);
        });
    }

    return (
      <Button
        color="done"
        onClick={() => {
          handleAproval(row);
        }}
        variant="contained"
        endIcon={getIcon(row)}
      >
        2/2
      </Button>
    );
  }

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const tableTheme = createTheme({
    palette: {
      virgin: createColor("#fc0303"),
      bastard: createColor("#fffb00"),
      done: createColor("#26ff00"),
    },
  });

  function switchthis(rowMe) {
    var s = (
      <Switch
        defaultChecked={rowMe.ForSale ? true : false}
        onChange={(e) => forsale(e, rowMe.id)}
      ></Switch>
    );

    return s;
  }

  async function forsale(t, id) {
    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id, state: t.target.checked ? 1 : 0 }),
      };
      await fetch(forsaleEndPoint, requestOptions)
        .then((response) => response.json())
        .then(function (data) {});
    } catch (e) {}
  }

  async function handleSaveUser(e) {
    var newPrice = parseFloat(e.values.value) * 100;
    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: e.row.original.id, newPrice: newPrice }),
      };

      await fetch(priceEndPoint, requestOptions)
        .then((response) => response.json())
        .then(function (data) {});
    } catch (e) {}
  }

  function logout() {
    sessionStorage.clear();
    setUserinfo(false);
    setIsAdmin(false);
    setAdminList(false);
  }

  function afterLogin() {
    setTimeout(() => {
      var u = JSON.parse(sessionStorage.getItem("userinfo"));
      setUserinfo(u);
      var h = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + u.token,
      };
      var options = {
        method: "GET",
        mode: "cors",
        headers: h,
      };

      const checkIfAdmin = async () => {
        await fetch(checkAdminEndPoint + u.id, options)
          .then((response) => response.json())
          .then(function (data) {
            setIsAdmin(data.isadmin);
          });
      };
      checkIfAdmin();
    }, 2000);
  }

  useEffect(() => {
    setLogin(false);
  }, [userinfo]);

  return (
    <div className={"MainW"}>
      {Login ? (
        <div>
          <Header bg={true} destination="/" from="about" />
          <LoginProcess callback={() => afterLogin()} />
        </div>
      ) : (
        <Container disableGutters={true} maxWidth="sm">
          <ThemeProvider theme={tableTheme}>
            <MaterialReactTable
              enableStickyHeader={true}
              enableFullScreenToggle={true}
              columns={adminList ? columnsAdmin : columns}
              initialState={
                adminList
                  ? {
                      isFullScreen: true,
                      columnVisibility: { shared: false, username: false },
                      sorting: [{ id: "APPR", desc: true }],
                    }
                  : { isFullScreen: true, columnVisibility: { value: false } }
              }
              data={FData ?? []}
              paging={false}
              enablePagination={false}
              state={{ isLoading }}
              displayColumnDefOptions={{ "mrt-row-actions": { size: 100 } }}
              enableRowActions
              positionActionsColumn="last"
              renderEditRowDialogContent={({
                table,
                row,
                internalEditComponents,
              }) => (
                <>
                  <DialogTitle variant="h3">Setup Phrase</DialogTitle>
                  <DialogContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1.5rem",
                    }}
                  ></DialogContent>
                  <DialogActions></DialogActions>
                </>
              )}
              onEditingRowSave={(e) => handleSaveUser(e)}
              renderRowActions={({ row, table }) => (
                <>
                  {row.original.APPR === 2 ||
                  row.original.approvals.length === 2 ? (
                    <Button
                      onClick={() =>
                        openInSameTab(
                          process.env.PUBLIC_URL + "/" + row.original.id
                        )
                      }
                    >
                      View
                    </Button>
                  ) : null}
                  {adminList ? (
                    <Button
                      onClick={() => {
                        if (
                          window.confirm(
                            `Delete this idea ?\n"${turnToPhrase(
                              row.original.phrase
                            )}"\nAre you sure? This cannot be undone`
                          )
                        )
                          handleDelete(row.original);
                      }}
                    >
                      Delete
                    </Button>
                  ) : userinfo ? (
                    userinfo.id !== row.original.user.id &&
                    !filterMine &&
                    !adminList ? (
                      <Button
                        onClick={() =>
                          openInSameTab(
                            process.env.PUBLIC_URL + "/buy/" + row.original.id
                          )
                        }
                      >
                        Buy
                      </Button>
                    ) : null
                  ) : row.original.ForSale === 1 ? (
                    <Button
                      onClick={() =>
                        openInSameTab(
                          process.env.PUBLIC_URL + "/buy/" + row.original.id
                        )
                      }
                    >
                      Buy
                    </Button>
                  ) : null}
                  {userinfo &&
                  userinfo.id === row.original.user.id &&
                  !adminList &&
                  filterMine ? (
                    <>
                      <Button
                        color="error"
                        onClick={() => table.setEditingRow(row)}
                      >
                        Change Price
                      </Button>
                      <FormControlLabel
                        control={switchthis(row.original)}
                        label="for Sale"
                        labelPlacement="start"
                      />
                      {row.original.approvals.length === 2 ? (
                        <Chip label="Aproved" color="success" size="small" />
                      ) : (
                        <Chip label="In Review" color="warning" size="small" />
                      )}
                    </>
                  ) : null}
                </>
              )}
              renderTopToolbarCustomActions={() => (
                <Box sx={{ display: "flex", gap: "1rem", p: "4px" }}>
                  {userinfo ? (
                    <Button
                      color="error"
                      onClick={() => {
                        logout();
                      }}
                      variant="contained"
                    >
                      Logout
                    </Button>
                  ) : (
                    <Button
                      color="success"
                      onClick={() => {
                        setLogin(true);
                      }}
                      variant="contained"
                    >
                      Login
                    </Button>
                  )}

                  <Button
                    color="primary"
                    onClick={() => {
                      openInSameTab(process.env.PUBLIC_URL + "/");
                    }}
                    variant="contained"
                  >
                    Back To Galaxy
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => {
                      openInSameTab(process.env.PUBLIC_URL + "/new");
                    }}
                    variant="contained"
                  >
                    Create Idea
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => {
                      setFData([]);
                    }}
                    variant="contained"
                  >
                    Refresh Table
                  </Button>
                  {!userinfo || adminList ? null : (
                    <Button
                      color="primary"
                      onClick={() => {
                        filter();
                      }}
                      variant="contained"
                    >
                      {filterMine ? "All" : "Manage Mine"}
                    </Button>
                  )}
                  {isAdmin ? (
                    <Button
                      color={adminList ? "success" : "error"}
                      onClick={() => {
                        fadminList();
                      }}
                      variant="contained"
                    >
                      Admin
                    </Button>
                  ) : null}
                </Box>
              )}
            />

            <GettingData />
          </ThemeProvider>
        </Container>
      )}
    </div>
  );
};

export default Buro;
